import React, { Component } from 'react';
import {Link} from 'react-router';
import Loading from 'components/LoadingComponent';
import Navigator from 'components/NavigatorComponent';
import LazyLoad from 'react-lazy-load';
import API from 'sources/API';

require('./Feature.scss');

class FeatureComponent extends Component{
  constructor(props) {
    super(props);
    this.state = {
			products: [],
			loading: false,
			hasMore: true,
			maxCount: 20,
			showNavigator: false,
			fetchTimeOut: null
    };
    this.onFeatureScroll = this.onFeatureScroll.bind(this)
    this.acquireProduects = this.acquireProduects.bind(this)
  }
  componentDidMount(){
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
          window.wx.config(json);
        }
      })
    }

    window.wx.ready(()=>{
      let imgUrl = 'https://img.xiaodiqiu.cn/share.png';
      window.wx.onMenuShareTimeline({
        title: `${this.props.location.query.name}——加入小地球旅行，发现本星球最有趣的地方`,
        link: location.href,
        imgUrl: imgUrl
      });
      window.wx.onMenuShareAppMessage({
        title: `${this.props.location.query.name}——小地球旅行`,
        desc: '加入小地球旅行，发现本星球最有趣的地方',
        link: location.href,
        type: 'link'
      });
    });

    window._hmt.push(['_trackPageview', this.props.location.pathname]);
    window.changeMetaForSEO(false);

		window.addEventListener('scroll',this.onFeatureScroll);
		window.scrollTo(0, 0);
		this.acquireProduects()
  }
  componentWillUnmount(){
    window.removeEventListener('scroll',this.onFeatureScroll);
  }
  onFeatureScroll(event) {
    if(this.state.fetchTimeOut) {
      clearTimeout(this.state.fetchTimeOut);
    }
    let scrollTop = $(document).scrollTop();
    let clientHeight = event.srcElement.body.clientHeight;
		let scrollHeight = event.srcElement.body.scrollHeight;
    if(scrollTop + clientHeight > scrollHeight) {
      this.setState({fetchTimeOut: setTimeout(this.acquireProduects, 1000)});
    }
    if(scrollTop > 500){
      this.setState({showNavigator:true});
    }else{
      this.setState({showNavigator:false});
    }
  }
  acquireProduects() {
		if (!this.state.hasMore) {
			return
		}

		this.setState({loading: true})
		const fetchUrl = API.getProductList;
		const feature_id = this.props.params.id;
		const type = this.props.location.query.type;

		if (type !== 'location' && type !== 'feature') {
			return
		}

		let sendData = {
			first: this.state.products.length + 1,
			maxCount: this.state.maxCount,
		};

		if (type === 'location') {
			sendData.country_id = feature_id
		}

		if (type === 'feature') {
			sendData.feature_id = feature_id
		}

		const searchParams = new URLSearchParams();
		for(let k in sendData) {
			if(sendData[k] === 0 || sendData[k]){
				searchParams.append(k, sendData[k]);
			}
		}
		
		fetch(`${fetchUrl}&${searchParams}`)
		.then(res=>res.json())
    .then(json=>{
			if (json.status == 0) {
				this.setState({
					products: this.state.products.concat(json.result),
					loading: false,
					hasMore: json.result.length == this.state.maxCount 
				})
			}
		}); 
  }
  render(){
    let navigator;
    if(this.state.showNavigator){
      navigator = <Navigator action='top' number="2" />;
		}
    return (
      <div className="feature-component">
				<div className="feature">
					#{this.props.location.query.name}
				</div>
        <div className="products">
          {this.state.products&&this.state.products.map(function(product){
            return (<Link to={`/route/${product._id}`} key={product._id} className="product">
            <LazyLoad throttle={50} debounce={true}><img className="cover" src={product.cover.big}></img></LazyLoad>
            <div className="pd-10">
              <div className="float left left-content">
                <div className="title">{product.title}</div>
                <div className="price mt-5">¥{product.price}&nbsp;起</div>
              </div>
              <div className="float right">
                <button className="tag fz-10">{product.feature.name?product.feature.name:'博物'}</button>
              </div>
              <div className="clear"></div>
            </div>
          </Link>)
          })}
        </div>
        <Loading loading={this.state.loading} hasMore={this.state.hasMore} loadMore={this.acquireProduects}/>
        {navigator}
        <Navigator action='left' />
      </div>
    );
  }
}

export default FeatureComponent;



// WEBPACK FOOTER //
// ./src/develop/FeatureComponent.js